import { WIDTH, HEIGHT } from "./constants";

export const CoverPage = ({ report, totalPages }) => (
  <div 
    className="bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 relative flex items-center justify-center"
    style={{ width: WIDTH, height: HEIGHT }}
    data-cover-page
  >
    <div className="text-center relative z-10">
      <h1 className="text-5xl font-bold text-white mb-3">{report.teamName}</h1>
      <p className="text-xl text-blue-200 mb-8">{report.year} Scouting Report</p>
      
      <div className="flex gap-8 justify-center">
        <div className="bg-white/10 backdrop-blur rounded-xl px-8 py-5 text-center">
          <div className="text-4xl font-bold text-white">{report.positionPlayers?.length || 0}</div>
          <div className="text-blue-200 text-sm mt-1">Hitters</div>
        </div>
        <div className="bg-white/10 backdrop-blur rounded-xl px-8 py-5 text-center">
          <div className="text-4xl font-bold text-white">{report.pitchers?.length || 0}</div>
          <div className="text-blue-200 text-sm mt-1">Pitchers</div>
        </div>
        <div className="bg-white/10 backdrop-blur rounded-xl px-8 py-5 text-center">
          <div className="text-4xl font-bold text-white">{totalPages}</div>
          <div className="text-blue-200 text-sm mt-1">Pages</div>
        </div>
      </div>
    </div>

    <div className="absolute bottom-6 left-8 right-8 text-center">
      <span className="text-blue-300/60 text-xs">
        Generated by D3 Dashboard • {new Date().toLocaleDateString()}
      </span>
    </div>
  </div>
);
